import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

const lineV = {
  hidden: { y: "112%" },
  show: (c) => ({ y: 0, transition: { duration: 1.1, ease: EASE, delay: c } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em] pr-[0.08em]">
        <motion.span className="block" variants={lineV} custom={delay + i * 0.11}>
          {line}
        </motion.span>
        {i < lines.length - 1 && " "}
      </span>
    ))}
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "", dark = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] flex items-center gap-3 ${dark ? "text-white/80" : "text-[var(--forest)]"} ${className}`}>
    <span className="inline-block h-2 w-2 rounded-full bg-[var(--lime)]" />
    {children}
  </p>
);
